<li ngbTooltip="{{text | translate}}" placement="right">
  <a [routerLink]="[href]">
    <i [ngClass]="getClassActiveFunction()" *ngIf="iconClasses" class="{{iconClasses}}"></i>
  </a>
</li>
